module.exports = __webpack_public_path__ + "img/rules.221165d5.png";